import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { notification } from 'antd';
import type { BaseQueryApi, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { keycloakInstance } from '../services/auth';

const createBaseQuery = (baseUrl: string) =>
  fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      const token = keycloakInstance.token;

      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }

      return headers;
    },
  });

const handleApiError = (error: FetchBaseQueryError) => {
  const errorMessage =
    (error.data as { message?: string })?.message ?? 'Произошла непредвиденная ошибка';

  notification.error({
    message: 'Ошибка',
    description: errorMessage,
    duration: 3,
  });
};

export const createAuthenticatedBaseQuery =
  (baseUrl: string) =>
  async (args: string | FetchArgs, api: BaseQueryApi, extraOptions: Record<string, unknown>) => {
    const baseQuery = createBaseQuery(`${baseUrl}`);

    let result = await baseQuery(args, api, extraOptions);

    if (result.error) {
      const error = result.error as FetchBaseQueryError;

      if (error.status === 401) {
        const refreshed = await keycloakInstance.updateToken(30);
        if (refreshed) {
          result = await baseQuery(args, api, extraOptions);
        } else {
          keycloakInstance.logout();
          return {
            error: {
              status: 401,
              data: { message: 'Unauthorized' },
            },
          };
        }
      }

      handleApiError(error);
    }

    return result;
  };
